import { Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, Type, ViewChild } from '@angular/core';
import { InjectComponentDirective } from '../inject-component.directive';
import { ListItem } from '../model/list';
import { UserFeedbackService } from '../user-feedback.service';

@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.css']
})
export class ListItemComponent implements OnInit {
  
  @Input() data: ListItem
  @Output() clicked: EventEmitter<any> = new EventEmitter()
  @ViewChild(InjectComponentDirective, {static: true}) listItem: InjectComponentDirective;
  
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private userFeedbackService: UserFeedbackService
  ) { }

  ngOnInit(): void {
    this.loadComponent()
  }

  loadComponent() {
    // compare class names and choose fitting list item component
    if (!this.data.layoutComponentRef) {
      console.error("No comopnent specified!!")
      return
    }
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.data.layoutComponentRef)
    const viewContainerRef = this.listItem.viewContainerRef
    const componentRef = viewContainerRef.createComponent(componentFactory)
    componentRef.instance.userFeedbackService = this.userFeedbackService
    componentRef.instance.data = this.data
  }
}
